import { HighscoreBoard } from '@/components/HighscoreBoard';

const Index = () => {
  return (
    <main>
      <HighscoreBoard />
    </main>
  );
};

export default Index;
